import React from 'react';
import { Link, useHistory } from 'react-router-dom';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import Button from '@/v2/components/atoms/Button';
import HotspotSmall from '@/v2/components/atoms/Icon/HotspotSmall';
import RefreshIcon from '@/v2/components/atoms/Icon/RefreshIcon';
import Text from '@/v2/components/atoms/Text';
import './Slide.scss';

const SUBMENU_BUTTON_VARIANT = 'icon-light';
const MAIN_SLIDE_BUTTON_VARIANT = 'primary-gold-light';

const propTypes = {
    className: PropTypes.string,
    data: PropTypes.object,
    noBackgroundMedia: PropTypes.bool,
};

const defaultProps = {
    className: '',
    data: null,
    noBackgroundMedia: true,
};

const Slide = ({ className, data, noBackgroundMedia }) => {
    const history = useHistory();

    const { latestRoute: route, submenu, text } = data;

    // first moment is "preview" moment for Design & Performance -- which  is not necessarily an item in <menu data>
    const getRoute = (index) => (index === 0 ? route : `${route}#${submenu[index].name}`);

    const onSubMenuClick = (e, index) => {
        e.preventDefault();
        history.push(getRoute(index));
    };

    const slideClasses = classNames({
        Slide: true,
        [className]: true,
        'start-animation': noBackgroundMedia,
    });

    return (
        <div className={slideClasses}>
            <section className="Slide__content-wrapper">
                <section className="Slide__content">
                    <div className="Slide__border-line" />
                    <section className="Slide__main-content">
                        <Text className="Slide__title" component="h2">
                            {text.title}
                        </Text>
                        <section className="Slide__submenu-wrapper">
                            {submenu?.length > 0 && (
                                <ul className="Slide__submenu-list">
                                    {submenu.map((item, index) => (
                                        <li className="Slide__submenu-item" key={submenu[index].name}>
                                            <Link to={getRoute(index)} onClick={(e) => onSubMenuClick(e, index)}>
                                                <Button
                                                    variant={SUBMENU_BUTTON_VARIANT}
                                                    icon={submenu[index].isVisited ? <RefreshIcon /> : <HotspotSmall />}
                                                    type="button"
                                                >
                                                    {item.label}
                                                </Button>
                                            </Link>
                                        </li>
                                    ))}
                                </ul>
                            )}
                        </section>
                        <Link to={route}>
                            <Button variant={MAIN_SLIDE_BUTTON_VARIANT} className="button-explore" type="button">
                                {text.cta.start}
                            </Button>
                        </Link>
                    </section>
                </section>
            </section>
        </div>
    );
};

Slide.propTypes = propTypes;
Slide.defaultProps = defaultProps;

export default Slide;
